// tslint:disable
export enum VirmedicaJobType {
    /**
     * @description Job for Virmedica callback events
     */
    VrmCallback = 1,
}
(VirmedicaJobType as any)['VRMCALLBACK'] = 1;
